import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=1514bfcd&"
import script from "./AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./AccountSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QItem,QItemSection,QItemLabel,QToggle,QSelect,QInput} from 'quasar'
component.options.components = Object.assign({QTable,QItem,QItemSection,QItemLabel,QToggle,QSelect,QInput}, component.options.components || {})
